<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="更换申请信息"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="40%"
    top="5%"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="140px" :rules="rules">
      <el-form-item
        v-if="item.Type === 0"
        label="产品型号名称"
        prop="DciProductModelID"
      >
        <select2
          style="width: 100%"
          labelName="NameNumber"
          v-model="modDciProductModelID"
          url="dci/model/product/list?order=name"
          :clearable="false"
          placeholder="请选择产品型号名称"
          no-data-text="没有产品型号名称"
          disabled
          :currentList="curDciProductModelID"
        ></select2>
      </el-form-item>
      <el-form-item v-if="item.Type === 0" label="产品SN" prop="DciProductID">
        <select2
          style="width: 100%"
          labelName="SN"
          v-model="item.DciProductID"
          :url="productUrl"
          :clearable="false"
          placeholder="请选择产品SN"
          disabled
          no-data-text="无产品"
          :currentList="curDciProductID"
        ></select2>
      </el-form-item>
      <el-form-item
        v-if="item.Type === 1"
        label="配件型号名称"
        prop="DciAccessoryModelID"
      >
        <select2
          style="width: 100%"
          labelName="NameNumber"
          v-model="modDciAccessoryModelID"
          url="dci/model/accessory/list?order=name"
          :clearable="false"
          placeholder="请选择配件型号名称"
          no-data-text="没有配件型号名称"
          disabled
          :currentList="curDciAccessoryModelID"
        ></select2>
      </el-form-item>
      <el-form-item v-if="item.Type === 1" label="配件SN" prop="DciAccessoryID">
        <select2
          style="width: 100%"
          labelName="SN"
          v-model="item.DciAccessoryID"
          :url="accessoryUrl"
          :clearable="false"
          placeholder="请选择配件SN"
          disabled
          no-data-text="无配件"
          :currentList="curDciAccessoryID"
        ></select2>
      </el-form-item>
      <el-form-item label="企业名称" prop="EntName">
        <el-input
          v-model.trim="item.EntName"
          placeholder="请输入企业名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="站点名称" prop="StationName">
        <el-input
          v-model.trim="item.StationName"
          placeholder="请输入站点名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否质保期" prop="IsWarrantyPeriod">
        <el-switch v-model="item.IsWarrantyPeriod"></el-switch>
      </el-form-item>
      <el-form-item label="是否我司运维期" prop="IsMaintenancePeriod">
        <el-switch v-model="item.IsMaintenancePeriod"></el-switch>
      </el-form-item>
      <el-form-item label="故障描述" prop="MalfunctionDesc">
        <el-input
          v-model.trim="item.MalfunctionDesc"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入故障描述"
        ></el-input>
      </el-form-item>
      <el-form-item label="维修方案" prop="MaintainScheme">
        <el-input
          v-model.trim="item.MaintainScheme"
          :autosize="{ minRows: 2 }"
          type="textarea"
          placeholder="请输入维修方案"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="success" @click="onPrint">
        <i class="fa fa-print"></i> 打 印
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      item: _.clone(this.value),
      modDciProductModelID: "",
      modDciAccessoryModelID: "",
      rules: {
        // DciProductID: [
        //   { required: true, message: "产品SN不能为空", trigger: "blur" },
        // ],
        // DciAccessoryID: [
        //   { required: true, message: "配件SN不能为空", trigger: "blur" },
        // ],
        EntName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        StationName: [
          { required: true, message: "站点名称不能为空", trigger: "blur" },
        ],
        IsWarrantyPeriod: [
          { required: true, message: "是否质保期不能为空", trigger: "blur" },
        ],
        IsMaintenancePeriod: [
          {
            required: true,
            message: "是否我司运维期不能为空",
            trigger: "blur",
          },
        ],
        MalfunctionDesc: [
          { required: true, message: "故障描述不能为空", trigger: "blur" },
        ],
        MaintainScheme: [
          { required: true, message: "维修方案不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      productUrl: "",
      accessoryUrl: "",
      curDciProductModelID: [],
      curDciProductID: [],
      curDciAccessoryModelID: [],
      curDciAccessoryID: [],
    };
  },
  watch: {
    modDciProductModelID: {
      handler() {
        this.productUrl = `dci/product/stock-list/list?where[DciProductModelID]=${this.modDciProductModelID}&order=-sn`;
      },
    },
    modDciAccessoryModelID: {
      handler() {
        this.accessoryUrl = `dci/accessory/stock-list/list?where[DciAccessoryModelID]=${this.modDciAccessoryModelID}&order=-sn`;
      },
    },
    "item.DciProductID": {
      handler() {
        this.$axios
          .get(`dci/product/${this.item.DciProductID}`)
          .then((response) => {
            this.proInfoItem = response.data;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      },
    },
    "item.DciAccessoryID": {
      handler() {
        this.$axios
          .get(`dci/accessory/${this.item.DciAccessoryID}`)
          .then((response) => {
            this.accInfoItem = response.data;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      },
    },
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  methods: {
    onOpen() {
      this.item = _.cloneDeep(this.value);

      this.initData();
    },
    initData() {
      //编辑状态
      if (this.item.DciProduct !== null) {
        this.modDciProductModelID = this.item.DciProduct.DciProductModelID;
        this.curDciProductModelID = [
          {
            ID: this.item.DciProduct.DciProductModelID,
            NameNumber: this.item.DciProduct.DciProductModel.NameNumber,
          },
        ];
        this.curDciProductID = [
          { ID: this.item.DciProductID, SN: this.item.DciProduct.SN },
        ];
      }
      if (this.item.DciAccessory !== null) {
        this.modDciAccessoryModelID =
          this.item.DciAccessory.DciAccessoryModelID;
        this.curDciAccessoryModelID = [
          {
            ID: this.item.DciAccessory.DciAccessoryModelID,
            NameNumber: this.item.DciAccessory.DciAccessoryModel.NameNumber,
          },
        ];
        this.curDciAccessoryID = [
          { ID: this.item.DciAccessoryID, SN: this.item.DciAccessory.SN },
        ];
      }
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    //打印更换申请单
    onPrint() {
      if (!this.item.ID) {
        this.$message.warning("请先保存更换申请信息");
        return;
      }

      this.$axios
        .get(`dci/maintain/confirm/print/${this.item.ID}`, {
          responseType: "blob", //服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'，默认是'json'
        })
        .then((res) => {
          if (!res) {
            return;
          }
          const blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型

          let fName = "更换申请表";
          if (this.item.DciProduct !== null) {
            fName += "(" + this.item.DciProduct.SN + ")";
          } else if (this.item.DciAccessory !== null) {
            fName += "(" + this.item.DciAccessory.SN + ")";
          }
          fName += ".xlsx";

          if (window.navigator.msSaveOrOpenBlob) {
            //兼容IE10
            navigator.msSaveBlob(blob, fName);
          } else {
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const a = document.createElement("a"); //创建a标签
            a.style.display = "none";
            a.href = href; // 指定下载链接
            a.download = fName; //指定下载文件名
            a.click(); //触发下载
            URL.revokeObjectURL(a.href); //释放URL对象
          }
          // 这里也可以不创建a链接，直接window.open(href)也能下载
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        const itemData = {
          ...this.item,
        };
        this.$axios
          .request({
            url: "dci/maintain/change",
            method: "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success("保存成功");
            this.submitting = false;
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.$emit("cancel");
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
          });
      });
    },
  },
};
</script>
